<template>
  <div class="popupError">
    <Div class="icon flex">
      <div class="checkAnimate">
        <i class="el-icon-warning-outline "></i>
      </div>
    </Div>
    <div class="text" v-html="text">
      <!-- {{text}} -->
    </div>
    <div class="btn">
      <button type="button" class="btn_primary" @click="checkBTN">確認</button>
    </div>
  </div>
</template>
<style lang="scss">
.popupError{
  font-size: 14px;
  letter-spacing: 2px;
  margin:0 auto;
  width: fit-content;
  .icon{
    margin:0 auto;
    background: #ff6a6a;
    width: 40px;
    height: 40px;
    border-radius: 50px;
    font-weight: bold;
    font-size: 25px;
    color: #fff;
    justify-content: center;
    align-items: center;
    animation: big 0.3s 0.1s backwards ease-in-out;
  }
  .text{
    margin:20px 0 0 0;
  }
  .btn{
    margin:20px 0 0 0;
  }
  .checkAnimate{
    animation: check 0.5s 0.1s backwards ease-in-out;
    // clip-path: inset(0 100% 0 0);
  }
}
</style>
<script>
export default {
  name:"popup_success",
  props:{
    text:String,
  },
  methods: {
    checkBTN(){
      this.$emit('check')
    }
  },
}
</script>